import React, { useState, useEffect } from "react";
import { CometChat } from "@cometchat-pro/chat";

// mui
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import SendIcon from "@mui/icons-material/Send";

type EditInputProps = {
  guid: string;
  textMsg: CometChat.TextMessage;
  handleMsgUpdate: (updatedMsg: CometChat.BaseMessage) => void;
};
const EditInput: React.FC<EditInputProps> = (props) => {
  const { guid, textMsg, handleMsgUpdate } = props;
  const [msg, setMsg] = useState("");
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMsg(event.target.value);
  };

  const inputRef = React.useRef<HTMLInputElement>();

  useEffect(() => {
    setMsg(textMsg.getText());
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [textMsg]);

  // https://www.cometchat.com/docs/javascript-chat-sdk/messaging-edit-message
  const updateTextMsg = () => {
    const receiverID = guid;
    const receiverType = CometChat.RECEIVER_TYPE.GROUP;
    const textMessage = new CometChat.TextMessage(receiverID, msg, receiverType);
    textMessage.setId(textMsg.getId());
    CometChat.editMessage(textMessage).then(
      (message: CometChat.BaseMessage) => {
        console.log("Message Edited", message);
        handleMsgUpdate(message);
      },
      (error: any) => {
        console.log("Message editing failed with error:", error);
      },
    );
  };
  const handleKeyboard = (event: React.KeyboardEvent<HTMLInputElement>) => {
    // cmd + Enter もしくは ctrl + Enter
    if (event.key === "Enter" && (event.ctrlKey || event.metaKey)) {
      updateTextMsg();
    }
  };

  return (
    <Box>
      <TextField
        inputRef={inputRef}
        size="small"
        fullWidth
        multiline
        maxRows={4}
        autoFocus={true}
        placeholder="Cmd+Enter/Ctrl+Enter to send"
        value={msg}
        onChange={handleChange}
        onKeyDown={handleKeyboard}
      />
      <Stack direction="row" justifyContent="flex-end">
        <IconButton onClick={updateTextMsg} size="small">
          <SendIcon />
        </IconButton>
      </Stack>
    </Box>
  );
};

export default EditInput;
